module.exports = __webpack_public_path__ + "static/media/meet_our_clients.86412ed6.jpg";